module.exports = __webpack_public_path__ + "img/eon.fc681c5a.png";